
// Гирлянда на Новый год
// Garland(v-if="user.isStaff() || project.id === PROJECT_ID_ADBISON")
// import Garland from '@/components/Garland.vue';
// Garland,

import {
  defineComponent,
  ref,
  computed,
} from 'vue';

import { useStore } from 'vuex';

import { useRoute } from 'vue-router';

import PrimeVueMessage from 'primevue/message';

import type { Project } from '@/types';

import { PROJECT_ID_ADBISON } from '@/libs/consts';

import useUser from '@/composable/useUser';

import TopBar from '@/components/TopBar.vue';

export default defineComponent({
  components: {
    PrimeVueMessage,
    TopBar,
  },
  setup() {
    const store = useStore();

    const route = useRoute();

    const { activeUser: user } = useUser();

    // A framed page scrolls itself, so it gets the whole viewport under the top bar, see NextFrame
    const frame = computed(() => Boolean(route.meta.frame));

    const layoutMobileActive = ref<boolean>(false);

    const layoutWrapperClass = computed(() => ({
      'layout-mobile-active': layoutMobileActive.value,
      'layout-topbar-light': store.getters.themeIsLight,
      'layout-menu-light': store.getters.themeIsLight,
      'layout-topbar-dark': store.getters.themeIsDark,
      'layout-menu-dark': store.getters.themeIsDark,
    }));

    const toggleMenu = (): void => {
      layoutMobileActive.value = !layoutMobileActive.value;
    };

    const onLayoutMaskClick = (): void => {
      toggleMenu();
    };

    return {
      PROJECT_ID_ADBISON,
      user,
      project: computed((): Project => store.getters.project),
      themeIsLight: computed((): boolean => store.getters.themeIsLight),
      layoutWrapperClass,
      frame,
      toggleMenu,
      onLayoutMaskClick,
    };
  },
});
